import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const store = new Vuex.Store({
	strict: process.env.NODE_ENV !== "production"
})

export async function when(condition: () => boolean, timeout: number | null = null): Promise<void> {
	if (condition())
		return

	return new Promise((resolve, reject) => {
		let timeoutHandler: number | null = null
		const unwatch = store.watch(condition, () => {
			unwatch()
			if (timeoutHandler !== null)
				clearTimeout(timeoutHandler)
			resolve()
		})
		if (timeout !== null) {
			timeoutHandler = window.setTimeout(() => {
				unwatch()
				reject(new Error("Timeout reached"))
			}, timeout)
		}
	})
}

export function nextTick(): Promise<void> {
	return Vue.nextTick()
}

export function watch<T>(getter: () => T, cb: (value: T, oldValue: T) => void, immediate?: boolean, deep?: boolean): () => void {
	return store.watch(getter, cb, {immediate, deep})
}

export default store
